/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Visit_PriceInputs */

const en_price_page_visit_price = /** @type {(inputs: Price_Page_Visit_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The specialist sets the price.`)
};

const pl_price_page_visit_price = /** @type {(inputs: Price_Page_Visit_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cenę ustala specjalista.`)
};

/**
* | output |
* | --- |
* | "The specialist sets the price." |
*
* @param {Price_Page_Visit_PriceInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_visit_price = /** @type {((inputs?: Price_Page_Visit_PriceInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Visit_PriceInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_visit_price(inputs)
	return en_price_page_visit_price(inputs)
});